import { useSidePanelStore } from "#stores/useSidePanelStore.ts";
import { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { useShallow } from "zustand/shallow";

export const useSidePanel = () => {
    const { isSidePanelOpen, closeSidePanel } = useSidePanelStore(useShallow(state => ({
        isSidePanelOpen: state.isSidePanelOpen,
        closeSidePanel: state.closeSidePanel
    })));

    const [isTransitionComplete, setIsTransitionComplete] = useState(false);
    const location = useLocation();

    // Handle the grid transition start
    const handleTransitionStart = (event: React.TransitionEvent<HTMLDivElement>) => {
        if (event.nativeEvent.propertyName === "grid-template-columns") {
            setIsTransitionComplete(false);
        }
    };

    // Handle the grid transition end
    const handleTransitionEnd = (event: React.TransitionEvent<HTMLDivElement>) => {
        if (event.propertyName === "grid-template-columns") {
            setIsTransitionComplete(isSidePanelOpen);
        }
    };

    // Close the message sources side panel when the route changes
    useEffect(() => {
        closeSidePanel();
    }, [closeSidePanel, location]);

    return {
        handleTransitionStart,
        handleTransitionEnd,
        isTransitionComplete,
        isSidePanelOpen
    };
};
